<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import type { SliceyMessageAuthor } from '../types/messageTypes'

interface Props {
  author: SliceyMessageAuthor
  text: string
}

defineProps<Props>()
</script>

<template>
  <Box
    class="bubble"
    :class="author === 'user' ? 'bubble--user' : 'bubble--assistant'"
    direction="col"
    gap="1"
  >
    <Text
      type="body-sm"
      :color="author === 'user' ? 'inverse' : 'default'"
      class="bubble__text"
    >
      {{ text }}
    </Text>
  </Box>
</template>

<style scoped>
.bubble {
  max-width: 85%;
  padding: 0.625rem 0.875rem;
  border-radius: 14px;
  word-wrap: break-word;
}

.bubble--user {
  align-self: flex-end;
  background: var(--p-primary-600);
  border-bottom-right-radius: 4px;
}

.bubble--assistant {
  align-self: flex-start;
  background: var(--p-surface-100);
  border: 1px solid var(--p-content-border-color);
  border-bottom-left-radius: 4px;
}

.bubble__text {
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>
